import { Injectable } from '@angular/core';
import { Router,ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from './authentication.service';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    constructor(private router: Router, private authService: AuthService) { }

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean  {
		return this.authService.isAuthenticatedAsync()
					.pipe(tap(isAuthenticated => this.handleAuthorization(isAuthenticated, state,route)));
	}
  
	private handleAuthorization(isAuthenticated: boolean, state: RouterStateSnapshot, route: ActivatedRouteSnapshot) 
	{
		if (!isAuthenticated){
			this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
		}else if (route.data.roles ) {
			for (var roleItem of route.data.roles)
			{
				if (this.authService.hasRole(roleItem)) {
					return true;
				}
			}
			//role not authorised so redirect to home page
			this.router.navigate(['/']);
			return false;
		}
	}
}




